export const APP_BASE_URL = 'https://intake.noorddigital.nl'

const MAIL_ENDPOINT = 'https://scan.noorddigital.nl/mail.php'

export async function submitIntake(
  htmlContent: string,
  clientEmail: string,
  clientName: string,
) {
  try {
    const formData = new FormData()
    formData.append('subject', `Nieuwe Website Intake – ${clientName}`)
    formData.append('email', clientEmail)
    formData.append('name', clientName)
    formData.append('html_body', htmlContent)
    formData.append('to', 'info@noorddigital.nl')

    console.log('[Intake Submit]', {
      endpoint: MAIL_ENDPOINT,
      name: clientName,
      email: clientEmail,
    })

    const response = await fetch(MAIL_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      body: formData,
    })

    if (!response.ok) {
      const errorText = await response.text()
      console.error('Server response:', response.status, errorText)
      throw new Error(
        `Server antwoordde met status ${response.status}: ${errorText || 'Geen details beschikbaar.'}`,
      )
    }

    await response.text()
    return { success: true }
  } catch (error) {
    console.error('Fout bij verzenden:', error)
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Onbekende fout bij verzenden.',
    }
  }
}
